import { render } from "./testsuiteview.vue?vue&type=template&id=912761dc"
import script from "./testsuiteview.vue?vue&type=script&lang=js"
export * from "./testsuiteview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__